import { useState, useEffect } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import { editarUsuarioBac } from "../api/bacAuthAPI";

const ESTADOS = [
  { v: "activo",    label: "✓ Activo",    color: "#2d6a4f" },
  { v: "pendiente", label: "⏳ Pendiente", color: "#b7791f" },
  { v: "inactivo",  label: "✕ Inactivo",  color: "#b3261e" },
];

export default function EditarUsuarioModal({ show, usuario, onClose, onGuardado }) {
  const [form, setForm] = useState({ nombre: "", cedula: "", rol: "gestor", estado: "activo", password: "" });
  const [error, setError] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (usuario) {
      setForm({ nombre: usuario.nombre, cedula: usuario.cedula, rol: usuario.rol, estado: usuario.estado, password: "" });
      setError("");
    }
  }, [usuario, show]);

  if (!usuario) return null;

  const guardar = async () => {
    if (!form.nombre || !form.cedula) {
      setError("Nombre y cédula son obligatorios");
      return;
    }
    setError("");
    setGuardando(true);
    try {
      const datos = { nombre: form.nombre, cedula: form.cedula, rol: form.rol, estado: form.estado };
      if (form.password) datos.password = form.password;
      await editarUsuarioBac(usuario.id, datos);
      onGuardado();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "No se pudo guardar");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #16342a, #2d6a4f)", color: "#fff" }}>
        <Modal.Title style={{ fontSize: "1rem" }}>✏️ Editar usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center gap-2 mb-3 p-2 rounded" style={{ background: "#f5f6f0" }}>
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#16342a", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 14, flexShrink: 0 }}>
            {usuario.nombre?.[0]?.toUpperCase() || "?"}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12.5, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{usuario.correo}</div>
            <div style={{ fontSize: 11, color: "#6c757d" }}>El correo no se puede cambiar desde aquí</div>
          </div>
        </div>

        <Form.Group className="mb-3">
          <Form.Label style={{ fontSize: 12.5, fontWeight: 700 }}>Nombre completo</Form.Label>
          <Form.Control value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label style={{ fontSize: 12.5, fontWeight: 700 }}>N° de cédula</Form.Label>
          <Form.Control value={form.cedula} onChange={e => setForm(p => ({ ...p, cedula: e.target.value }))} />
        </Form.Group>

        <div className="row g-3 mb-3">
          <div className="col-6">
            <Form.Label style={{ fontSize: 12.5, fontWeight: 700 }}>Rol</Form.Label>
            <Form.Select value={form.rol} onChange={e => setForm(p => ({ ...p, rol: e.target.value }))}>
              <option value="gestor">Gestor</option>
              <option value="admin">Admin</option>
            </Form.Select>
          </div>
          <div className="col-6">
            <Form.Label style={{ fontSize: 12.5, fontWeight: 700 }}>Estado</Form.Label>
            <Form.Select value={form.estado} onChange={e => setForm(p => ({ ...p, estado: e.target.value }))}>
              {ESTADOS.map(e => <option key={e.v} value={e.v}>{e.label}</option>)}
            </Form.Select>
          </div>
        </div>

        <Form.Group className="mb-2">
          <Form.Label style={{ fontSize: 12.5, fontWeight: 700 }}>Nueva contraseña</Form.Label>
          <Form.Control type="password" placeholder="Dejar vacío para no cambiarla" value={form.password}
            onChange={e => setForm(p => ({ ...p, password: e.target.value }))} />
        </Form.Group>

        {error && <Alert variant="danger" className="py-2 mt-2" style={{ fontSize: 12.5 }}>{error}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>Cancelar</Button>
        <Button variant="success" onClick={guardar} disabled={guardando} style={{ background: "#16342a", border: "none" }}>
          {guardando ? "Guardando..." : "Guardar cambios"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
